<div class="main-container">
  <ng-container *ngIf="{
        busy: facade.editorBusy$ | async,
        loadError: facade.editorLoadError$ | async,
        saveError: facade.editorSaveError$ | async
      } as state">
    <div class="card">
      <div class="card-header">
        <h1>{{ 'title.algorithm_editor' | translate }}</h1>
      </div>
      <div class="card-body">
        <form [formGroup]="form" (ngSubmit)="submit()" *ngIf="form && (!state.busy || form.dirty)">
          <p class="error-message" *ngIf="state.loadError || state.saveError">{{ state.loadError || state.saveError }}
          </p>

          <mat-label class="field-label">{{ 'core.name' | translate | uppercase }}</mat-label>
          <mat-form-field class="full-width" appearance="outline">
            <input matInput formControlName="name" data-cy="algorithm-editor-name" />
          </mat-form-field>

          <mat-label class="field-label">{{ 'core.description' | translate | uppercase }}</mat-label>
          <mat-form-field class="full-width" appearance="outline">
            <textarea matInput formControlName="description" rows="4" data-cy="algorithm-editor-description"></textarea>
          </mat-form-field>

          <mat-label class="field-label">{{ 'core.version' | translate | uppercase }}</mat-label>
          <mat-form-field class="full-width" appearance="outline">
            <input matInput formControlName="version" data-cy="algorithm-editor-version" />
          </mat-form-field>

          <div class="regulated-field">
            <mat-checkbox formControlName="regulated" data-cy="algorithm-editor-regulated">
              {{ 'table.algorithms.columns.regulated' | translate }}
            </mat-checkbox>
          </div>
        </form>

        <div class="loading" *ngIf="state.busy && !form.dirty">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      </div>
      <div class="card-footer card-actions">
        <button type="button" class="btn btn-outline-primary card-actions__action" (click)="cancel()"
          data-cy="algorithm-editor-cancel">
          <i class="ri-close-fill"></i>{{ 'button.cancel' | translate }}
        </button>
        <button type="button" class="btn btn-primary card-actions__action" (click)="submit()"
          [disabled]="form.invalid || !form.dirty || state.busy" data-cy="algorithm-editor-save">
          <i class="ri-save-line"></i>{{ 'button.save' | translate }}
        </button>
      </div>
    </div>
  </ng-container>
</div>
